"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeOptions = exports.colorPalette = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
/**
 * Stores the default color palette.
 */
exports.colorPalette = [
    '#667EEA',
    '#F56565',
    '#48BB78',
    '#ED8936',
    '#9F7AEA',
    '#38B2AC',
    '#ECC94B',
    '#4299E1',
    '#ED64A6',
];
/**
 * Used to merge different nested options.
 */
exports.mergeOptions = deepmerge_1.default;
